import { render, staticRenderFns } from "./Thumb.vue?vue&type=template&id=2802d5d3&scoped=true&"
import script from "@/scripts/QA/Question/components/Thumb?vue&type=script&lang=js&"
export * from "@/scripts/QA/Question/components/Thumb?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2802d5d3",
  null
  
)

export default component.exports